module.exports = __webpack_public_path__ + "assets/img/img2.c8079707.png";